import { postRequest } from "../apis/axiosAction";
import { isAdminUser } from "../components/auth/authUser";
import { getFirebaseUserInfo, getFirebaseAuthToken } from "../firebase/firebase";

// 管理ユーザーホーム画面表示店舗リスト
const specialUserDoCodeList = ["201", "290", "380", "457", "701"];
const specialUserTenpoCodeList = [
  "546331",
  "130531",
  "432321",
  "297840",
  "532694",
  "462551",
  "161619",
  "325311",
  "396707",
  "353483",
  "455166",
  "488059",
];

export const userInfo: any = {
  employee_no: "",
  employee_name: "",
  mail_address: "",
  department_code_OA: "",
  department_name_OA: "",
  job_category_code_OA: "",
  job_category_name_OA: "",
  do_code: [],
  zo_code: [],
  tenpo_code: [],
  tenpo_code_special_list: [],
  hq_department_code_OA: "",
  hq_department_name_OA: "",
  permission_code: []
};

// ユーザー情報を返す
export const getUserInfo = () => {
  const userInfoFromSession = sessionStorage.getItem("userInfo");
  if (userInfoFromSession) {
    return JSON.parse(userInfoFromSession);
  }
  return userInfo;
};

// ユーザー情報を格納
export const setUserInfo = (json: any, permissionCode: string[] = []) => {
  const baseDoCodes = json.do_code || [];
  const baseTenpoCodes = json.tenpo_code || [];

  // Firebaseの認証情報からメールアドレスを取得
  const firebaseUser = getFirebaseUserInfo();
  const emailFromFirebase = firebaseUser?.email || "";

  // APIからの情報とFirebaseからの情報をマージ
  const userInfoForAuthCheck = {
    ...json,
    mail_address: json.mail_address || emailFromFirebase,
    permission_code: permissionCode,
  };

  const adminDoCodes = isAdminUser(userInfoForAuthCheck) ? specialUserDoCodeList : [];
  const adminTenpoCodes = isAdminUser(userInfoForAuthCheck) ? specialUserTenpoCodeList : [];

  const newUserInfo = {
    employee_no: json.employee_no || "",
    employee_name: json.employee_name || "",
    mail_address: json.mail_address || emailFromFirebase,
    department_code_OA: json.department_code_OA || "",
    department_name_OA: json.department_name_OA || "",
    job_category_name_OA: json.job_category_name_OA || "",
    job_category_code_OA: json.job_category_code_OA || "",
    do_code: Array.from(new Set([...baseDoCodes, ...adminDoCodes])),
    zo_code: json.zo_code || [],
    tenpo_code: Array.from(new Set([...baseTenpoCodes, ...adminTenpoCodes])),
    tenpo_code_special_list: json.tenpo_code_special_list || [],
    hq_department_code_OA: json.hq_department_code_OA || "",
    hq_department_name_OA: json.hq_department_name_OA || "",
    permission_code: permissionCode,
  };
  sessionStorage.setItem("userInfo", JSON.stringify(newUserInfo));
  Object.assign(userInfo, newUserInfo);
};

// home画面で取得した店舗コードをuserInfoに格納
export const setHomeTenpoCodeList = (tenpoCodeList: string[]) => {
  const userInfoFromSession = sessionStorage.getItem("userInfo");
  if (userInfoFromSession) {
    const currentUserInfo = JSON.parse(userInfoFromSession);
    const existingTenpoCodes = currentUserInfo.tenpo_code || [];
    
    const mergedTenpoCodes = Array.from(new Set([...existingTenpoCodes, ...tenpoCodeList]));
    
    const newUserInfo = {
      ...currentUserInfo,
      tenpo_code: mergedTenpoCodes,
    };
    
    sessionStorage.setItem("userInfo", JSON.stringify(newUserInfo));
    Object.assign(userInfo, newUserInfo);
  }
};

// ユーザー情報があるかどうかを返す
export const isUserInfo = () => {
  const userInfoFromSession = sessionStorage.getItem("userInfo");
  if (!userInfoFromSession) {
    return false;
  }
  const userInfo = JSON.parse(userInfoFromSession);
  return userInfo.employee_no !== null && userInfo.employee_no !== "";
};

// ユーザー情報をクリアする関数
export const clearUserInfo = () => {
  userInfo.employee_no = "";
  userInfo.employee_name = "";
  userInfo.mail_address = "";
  userInfo.department_code_OA = "";
  userInfo.department_name_OA = ""
  userInfo.job_category_code_OA = "";
  userInfo.job_category_name_OA = "";
  userInfo.do_code = [];
  userInfo.zo_code = [];
  userInfo.tenpo_code = [];
  userInfo.tenpo_code_special_list = [];
  userInfo.department_name_OA = "";
  userInfo.hq_department_code_OA = "";
  userInfo.hq_department_name_OA = "";
  userInfo.permission_code = [];
};

// 初期処理
export const initialOperation = async () => {
  // ユーザー情報APIの呼び出し（デジタルツールのfirestoreのデータ）
  await postRequest(
    process.env.REACT_APP_COMMON_API!,
    {
      "api-name": "user-info",
    },
    false
  )
    .then(async (response: any) => {
      // レスポンスデータの存在確認
      if (!response || !response.data || !response.data.dataList || response.data.dataList.length === 0) {
        console.error("ユーザー情報APIのレスポンスが空です:", response);
        throw new Error("ユーザー情報が取得できませんでした");
      }

      const json = JSON.parse(response.data.dataList[0]);

      // 権限情報をAlloyDBから取得
      let permissionCode: string[] = [];
      try {
        const authorityResponse = await fetchAuthorityInfo(json);
        permissionCode = authorityResponse?.permission_code || [];
      } catch (error) {
        console.error("権限情報の取得に失敗しました:", error);
        // 権限情報取得失敗時は空配列で続行
      }

      setUserInfo(json, permissionCode);
      console.log("ユーザー情報を設定しました:", json.employee_no);

      if (!getSyncTenpoCodesPromise()) {
        syncTenpoCodes().catch(() => {});
      }

      return true;
    })
    .catch((error: any) => {
      console.error("Error App initialOperation1: ", error);
      throw error;
    });
};

  // ユーザの権限情報をAlloyDBから取得
  export const fetchAuthorityInfo = async (userInfoParam?: any) => {
    // パラメータが渡された場合はそれを使用、なければsessionStorageから取得
    const userInfoToUse = userInfoParam || getUserInfo();

    // Firebaseの認証情報からメールアドレスを取得（フォールバック用）
    const firebaseUser = getFirebaseUserInfo();
    const emailFromFirebase = firebaseUser?.email || "";

    const mailaddress = userInfoToUse.mail_address || emailFromFirebase;
    const departmentCodeOA = userInfoToUse.department_code_OA || "";
    const jobCategoryCodeOA = userInfoToUse.job_category_code_OA || "";

    // GraphQL Query形式でAlloyDBから権限コードを取得
    const response = await postRequest(
      process.env.REACT_APP_OFC_DASHBOARD_GRAPHQL! + "/graphql",
      {
        query: `query GetUserPermissions($mailaddress: String!, $department_code_OA: String!, $job_category_code_OA: String!) {
          getUserPermissions(
            mailaddress: $mailaddress
            department_code_OA: $department_code_OA
            job_category_code_OA: $job_category_code_OA
          ) {
            permission_code
          }
        }`,
        variables: {
          mailaddress: mailaddress,
          department_code_OA: departmentCodeOA,
          job_category_code_OA: jobCategoryCodeOA
        }
      },
      true  // GraphQL形式
    );

    // GraphQLレスポンスからpermission_codeの配列を取得
    if (response?.data?.data?.getUserPermissions) {
      const permissionList = response.data.data.getUserPermissions;
      // UserPermissionオブジェクトの配列から permission_code だけを抽出
      const permissionCodes = permissionList.map((item: any) => item.permission_code);
      return { permission_code: permissionCodes };
    }

    return { permission_code: [] };
  };

let syncTenoCodesPromise: Promise<void> | null = null;
export const getSyncTenpoCodesPromise = (): Promise<void> | null => syncTenoCodesPromise;

// Firebase Auth Custom Claims に tenpo_codes と is_admin を設定
export const syncTenpoCodes = async (userInfoParam?: any): Promise<void> => {
  const userInfoToUse = userInfoParam || getUserInfo();

  const firebaseUser = getFirebaseUserInfo();
  const emailFromFirebase = firebaseUser?.email || "";

  const tenpoCodes: string[] = userInfoToUse.tenpo_code || [];
  const mailaddress = userInfoToUse.mail_address || emailFromFirebase;
  const departmentCodeOA = userInfoToUse.department_code_OA || "";
  const jobCategoryCodeOA = userInfoToUse.job_category_code_OA || "";

  const doSync = async () => {
    try {
      const response = await postRequest(
        process.env.REACT_APP_OFC_DASHBOARD_GRAPHQL! + "/graphql",
        {
          query: `mutation SyncTenpoCodes($tenpoCodes: [String!]!, $mailaddress: String!, $departmentCodeOA: String!, $jobCategoryCodeOA: String!) {
            syncTenpoCodes(
              tenpoCodes: $tenpoCodes
              mailaddress: $mailaddress
              departmentCodeOA: $departmentCodeOA
              jobCategoryCodeOA: $jobCategoryCodeOA
            ) {
              success
              is_admin
              message
            }
          }`,
          variables: {
            tenpoCodes,
            mailaddress,
            departmentCodeOA,
            jobCategoryCodeOA,
          },
        },
        true,
      );

      const result = response?.data?.data?.syncTenpoCodes;
      if (result?.success) {
        await getFirebaseAuthToken(true);
        console.log("[syncTenpoCodes] Custom Claims 設定完了:", { is_admin: result.is_admin });
      } else {
        console.error("[syncTenpoCodes] 失敗:", result?.message, "レスポンス全体:", JSON.stringify(response?.data));
      }
    } catch (error) {
      syncTenoCodesPromise = null;
      console.error("syncTenpoCodes エラー:", error);
      throw error;
    }
  };

  syncTenoCodesPromise = doSync();
  return syncTenoCodesPromise;
};

